import authRequest from '../authRequest';
import ReferralPresenter from '../../presenters/ReferralPresenter';

const fetchReferralsList = async (currentPage = 1, params = {}) => {
  const searchParams = new URLSearchParams({ page: currentPage, ...params });
  try {
    const response = await authRequest(`/user_referrals?${searchParams.toString()}`, { method: 'GET' });

    if (response.status !== 200) throw new Error('Fetching referrals failed');

    const referrals = (response.data.referrals || []).map((item) => new ReferralPresenter(item));

    const pagination = {
      current: response.data.meta?.current_page || 1,
      pageSize: response.data.meta?.per_page || 10,
      total: response.data.meta?.total_entries || referrals.length,
    };

    return { referrals, pagination };
  } catch (error) {
    // Fallback: return empty state if API not available yet
    return { referrals: [], pagination: { current: 1, pageSize: 10, total: 0 } };
  }
};

export default fetchReferralsList;



